import { render, staticRenderFns } from "./MessageTip.vue?vue&type=template&id=5f1f200e&scoped=true&"
import script from "./MessageTip.vue?vue&type=script&lang=js&"
export * from "./MessageTip.vue?vue&type=script&lang=js&"
import style0 from "./MessageTip.vue?vue&type=style&index=0&id=5f1f200e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1f200e",
  null
  
)

export default component.exports